import { Element } from 'slate';
import { BlockElement } from '../../types';

export const genericLtiType = 'genericLti';

// type guard
export const isGenericLtiElement = (
  element: Element
): element is BlockElement => element.type === genericLtiType;
